import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';

domReady(() => {
  const newsEventsCarousels = document.querySelectorAll(
    '.carrousel-events .carrousel-events__carousel'
  );

  if (0 < newsEventsCarousels.length) {
    newsEventsCarousels.forEach((newsEventsCarousel) => {
      new Swiper(newsEventsCarousel, {
        slidesPerView: 1,
        spaceBetween: 24,
        navigation: {
          nextEl: '.carrousel-events__next.swiper-button-next',
          prevEl: '.carrousel-events__prev.swiper-button-prev',
        },
        breakpoints: {
          600: {
            slidesPerView: 2,
          },
          900: {
            slidesPerView: 2.75,
          },
        },
      });
    });
  }
});
